<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-3/12">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totals.filter.amount | moneyNoDecimal(currency) }} ({{ totals.filter.count || '-' }})</h2>
                <span>Total (Filtro)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-3/12">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totals.active.amount | moneyNoDecimal(currency) }} ({{ totals.active.count || '-' }})</h2>
                <span>Ativa</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-3/12">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
                style="background: rgba(var(--vs-warning),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totals.suspended.amount | moneyNoDecimal(currency) }} ({{ totals.suspended.count || '-' }})</h2>
                <span>Suspensa / Vencida</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-3/12">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                style="background: rgba(var(--vs-danger),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totals.cancelled.amount | moneyNoDecimal(currency) }} ({{ totals.cancelled.count || '-' }})</h2>
                <span>Cancelada</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div id="data-list-list-view" class="data-list-container mt-5">
      <div class="flex mb-4 px-2">
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="Número" v-model="filters.id"/>
        </div>
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="ID Gateway" v-model="filters.id_gateway"/>
        </div>
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="E-mail" v-model="filters.email"/>
        </div>
        <div class="flex-1 px-2">
          <vs-input class="w-100 inputx" placeholder="CPF/CNPJ" v-model="filters.cpfcnpj"/>
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Data Inicial"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.created_at.start"
          />
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Data Final"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.created_at.end"/>
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Renovação Inicial"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.renew_at.start"
          />
        </div>
        <div class="flex-1 px-2">
          <Datepicker
            :language="ptBR"
            :clear-button="true"
            placeholder="Renovação Final"
            :use-utc="true"
            format="dd/MM/yyyy"
            v-model="filters.renew_at.end"/>
        </div>
        <div class="flex-1 px-2">
          <v-select
            multiple
            :closeOnSelect="false"
            v-model="filters.status.selected"
            :options="filters.status.options"
            placeholder="Situação"
          />
        </div>
      </div>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="subscriptions.last_page" v-model="subscriptions.current_page"></vs-pagination>
        </div>
      </div>

      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado no período selecionado"
        :data="data"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>ID GATEWAY</vs-th>
          <vs-th>EMAIL/PLANO</vs-th>
          <vs-th>CRIADA EM</vs-th>
          <vs-th>ATUALIZADA EM</vs-th>
          <vs-th>RENOVA EM</vs-th>
          <vs-th>VENDA/LICENÇAS</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td :data="data[idx].id">
              <router-link :to="{ name: 'assinatura-detalhes', params: { id: data[idx].id } }">{{ data[idx].id }}</router-link>
            </vs-td>
            <vs-td>
              <a :href="`https://www.paypal.com/billing/subscriptions/${data[idx].paypal_subscription_id}`" target="_blank" v-if="data[idx].paypal_subscription_id">
                {{ data[idx].paypal_subscription_id }}
              </a>
              <a :href="`https://dashboard.stripe.com/subscriptions/${data[idx].stripe_subscription_id}`" target="_blank" v-if="data[idx].stripe_subscription_id">
                {{ data[idx].stripe_subscription_id }}
              </a>
              <a :href="`https://alia.iugu.com/receive/billing/${data[idx].iugu_subscription_id}`" target="_blank" v-if="data[idx].iugu_subscription_id">
                {{ data[idx].iugu_subscription_id }}
              </a>
              <a :href="`https://app.galaxpay.com.br/detalhes-contrato-venda/${data[idx].galaxpay_subscription_id}`" target="_blank" v-if="data[idx].galaxpay_subscription_id">
                {{ data[idx].galaxpay_subscription_id }}
              </a>
            </vs-td>
            <vs-td v-if="data[idx].user" :data="data[idx].user.email">
              <router-link
                :to="{ name: 'cliente-detalhes', params: { id: data[idx].user.id } }"
              >{{ data[idx].user.email }}
              </router-link>
              <br>
              {{ data[idx].plan.name }}
            </vs-td>
            <vs-td v-if="!data[idx].user">-</vs-td>
            <vs-td :data="data[idx].created_at">{{ data[idx].created_at | formatDateTime }}</vs-td>
            <vs-td :data="data[idx].updated_at">{{ data[idx].updated_at | formatDateTime }}</vs-td>
            <vs-td :data="data[idx].renew_at">{{ data[idx].renew_at | formatDate }}</vs-td>
            <vs-td>
              <div v-if="data[idx].order">
                <router-link v-if="data[idx].order" :to="{ name: 'venda-detalhes', params: { id: data[idx].order.id } }">{{ data[idx].order.number }}</router-link>
              </div>
              {{ data[idx].licences.length }}
            </vs-td>
            <vs-td
              :class="{
                'text-success': data[idx].status == 'Ativa' || data[idx].status == 'Aprovada',
                'text-warning': data[idx].status == 'Aguardando Pagamento' || data[idx].status == 'Aguardando Aprovação' || data[idx].status == 'Suspensa',
                'text-danger': data[idx].status.indexOf('Cancelada') > -1 || data[idx].status.indexOf('Vencida') > -1 || data[idx].status.indexOf('Incompleta') > -1 || data[idx].status.indexOf('Não Paga') > -1
              }"
            >
              <span class="flex items-center px-2 py-1 rounded">
                <div
                  class="h-3 w-3 rounded-full mr-2"
                  :class="{
                      'bg-success': data[idx].status == 'Ativa' || data[idx].status == 'Aprovada',
                      'bg-warning': data[idx].status == 'Aguardando Pagamento' || data[idx].status == 'Aguardando Aprovação' || data[idx].status == 'Suspensa',
                      'bg-danger': data[idx].status.indexOf('Cancelada') > -1 || data[idx].status.indexOf('Vencida') > -1 || data[idx].status.indexOf('Incompleta') > -1 || data[idx].status.indexOf('Não Paga') > -1
                    }"
                ></div>
                {{ data[idx].status }}
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="subscriptions.last_page" v-model="subscriptions.current_page"></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    'v-select': vSelect,
    Datepicker
  },
  data() {
    return {
      ptBR,
      subscriptions: {
        current_page: 1,
        last_page: 1
      },
      totals: {
        active: {
          count: 0,
          amount: 0
        },
        filter: {
          count: 0,
          amount: 0
        },
        suspended: {
          count: 0,
          amount: 0
        },
        cancelled: {
          count: 0,
          amount: 0
        }
      },
      filters: {
        id_gateway: null,
        created_at: {
          start: null,
          end: null
        },
        renew_at: {
          start: null,
          end: null
        },
        status: {
          options: ['Ativa', 'Aguardando Aprovação', 'Cancelada', 'Incompleta', 'Não Paga', 'Suspensa', 'Vencida'],
          selected: []
        }
      },
      data: [],
      timeout: null,
      currency: 'BRL'
    }
  },

  mounted() {
    const filters = JSON.parse(
      localStorage.getItem(`filters-${this.$route.fullPath}`)
    )

    if (filters) {
      filters.status.options = this.filters.status.options
      this.filters = filters
    }

    const query = this.$route.query
    if (query.status) {
      this.filters.status.selected = [query.status]
    }

    this.currency = localStorage.getItem('currency') || 'BRL'
  },

  methods: {
    load() {
      this.$vs.loading()

      localStorage.setItem(
        `filters-${this.$route.fullPath}`,
        JSON.stringify(this.filters)
      )

      this.$api
      .get('/api/v1/backend/subscriptions', {
        params: {
          page: this.subscriptions.current_page,
          currency: localStorage.getItem('currency') || 'BRL',
          filters: this.filters
        }
      })
      .then(response => {
        this.$vs.loading.close()
        this.data = response.data.subscriptions.data
        this.subscriptions = response.data.subscriptions
        this.totals = response.data.totals
      })
    }
  },

  watch: {
    filters: {
      handler() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.load()
        }, 600)
      },
      deep: true
    },
    'subscriptions.current_page'() {
      this.load()
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
